// "use client"

// import { useState, useEffect } from "react"
// import { useDispatch, useSelector } from "react-redux"
// import { useNavigate, useLocation } from "react-router-dom"
// import { PhoneIcon, ShieldCheckIcon, ArrowRightIcon, EnvelopeIcon, CheckCircleIcon } from "@heroicons/react/24/outline"

// // Assuming these are correctly configured and available
// import { auth, setupRecaptcha, signInWithPhoneNumber } from "../../../firebaseConfig"
// import { CheckPhoneVerifyAsync } from "../Slice/PhoneVerified/CheckPhoneVerifySlice"
// import {
//   generateEmailVerificationPublicAsync,
//   checkEmailVerificationPublicAsync,
//   resetEmailVerificationState,
// } from "../Slice/EmailVerificationSignup/EmailVerificationSignupSlice"
// import { checkPhoneVerificationPublicAsync, resetPhoneVerificationState } from "../Slice/PhoneVerificationSignup/PhoneVerificationSignupSlice"

// function PhoneVerification() {
//   const location = useLocation()
//   const [mobile, setMobile] = useState(location.state?.phone || "")
//   const [email, setEmail] = useState(location.state?.email || "")
//   const [otp, setOtp] = useState("")
//   const [confirmationResult, setConfirmationResult] = useState(null)
//   const [error, setError] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [successMessage, setSuccessMessage] = useState("")
//   const [isPhoneVerified, setIsPhoneVerified] = useState(false)
//   const [otpSent, setOtpSent] = useState(false)

//   // Email verification states
//   const [emailOtp, setEmailOtp] = useState("")
//   const [emailError, setEmailError] = useState("")
//   const [emailSuccessMessage, setEmailSuccessMessage] = useState("")
//   const [isEmailVerified, setIsEmailVerified] = useState(false)

//   const dispatch = useDispatch()
//   const navigate = useNavigate()

//   // Phone verification state from Redux
//   const {
//     loading: phoneLoading,
//     success: phoneVerifiedRedux,
//     error: phoneReduxError,
//   } = useSelector((state) => state.phoneVerificationPublic || {})

//   // Email verification state from Redux
//   const {
//     loading: emailLoading,
//     otpSent: emailOtpSentRedux,
//     success: emailVerifiedRedux,
//     error: emailReduxError,
//   } = useSelector((state) => state.emailVerificationPublic || {})

//   // Setup recaptcha when component mounts
//   useEffect(() => {
//     const initializeRecaptcha = () => {
//       try {
//         setupRecaptcha()
//       } catch (error) {
//         console.error("Error initializing recaptcha:", error)
//       }
//     }
//     const timer = setTimeout(initializeRecaptcha, 100)
//     return () => {
//       clearTimeout(timer)
//       if (window.recaptchaVerifier) {
//         window.recaptchaVerifier.clear()
//         window.recaptchaVerifier = null
//       }
//     }
//   }, [])

//   // Reset verification states on component mount
//   useEffect(() => {
//     dispatch(resetEmailVerificationState())
//     dispatch(resetPhoneVerificationState())
//   }, [dispatch])

//   // Handle phone verification success
//   useEffect(() => {
//     if (phoneVerifiedRedux) {
//       setIsPhoneVerified(true)
//       setSuccessMessage("Phone verification successful!")
//       setOtp("")
//       setTimeout(() => {
//         navigate(location.state?.redirectTo || "/employer-basics", {
//           state: {
//             country_uuid: location.state?.country_uuid,
//             state_uuid: location.state?.state_uuid,
//             city_uuid: location.state?.city_uuid,

//           }
//         });
//       }, 1500);
//     }
//   }, [phoneVerifiedRedux, navigate, location.state])

//   // Handle phone verification error
//   useEffect(() => {
//     if (phoneReduxError) {
//       setError(phoneReduxError)
//     }
//   }, [phoneReduxError])

//   // Handle email verification success
//   useEffect(() => {
//     if (emailVerifiedRedux) {
//       setIsEmailVerified(true)
//       setEmailSuccessMessage("Email verification successful!")
//       setEmailOtp("")
//     }
//   }, [emailVerifiedRedux])

//   // Handle email verification error
//   useEffect(() => {
//     if (emailReduxError) {
//       setEmailError(emailReduxError)
//     }
//   }, [emailReduxError])

//   useEffect(() => {
//     console.log("Email OTP Sent Redux State:", emailOtpSentRedux)
//     console.log("Is Email Verified State:", isEmailVerified)
//   }, [emailOtpSentRedux, isEmailVerified])

//   const formatPhoneNumber = (phone) => {
//     const cleaned = phone.replace(/\D/g, "")
//     if (phone.startsWith("+91")) {
//       return phone
//     }
//     if (cleaned.length === 10) {
//       return `+91${cleaned}`
//     }
//     if (cleaned.startsWith("91") && cleaned.length === 12) {
//       return `+${cleaned}`
//     }
//     return `+91${cleaned}`
//   }

//   const validatePhoneNumber = (phone) => {
//     const cleaned = phone.replace(/\D/g, "")
//     return cleaned.length === 10 || (cleaned.length === 12 && cleaned.startsWith("91"))
//   }

//   const sendOtp = async (e) => {
//     e.preventDefault()
//     setError("")
//     setSuccessMessage("")
//     setLoading(true)
//     const latestMobile = mobile.trim()

//     if (!latestMobile) {
//       setError("Please enter a valid phone number.")
//       setLoading(false)
//       return
//     }

//     if (!validatePhoneNumber(latestMobile)) {
//       setError("Please enter a valid 10-digit phone number.")
//       setLoading(false)
//       return
//     }

//     try {
//       // First check if phone is already verified
//       const result = await dispatch(CheckPhoneVerifyAsync(latestMobile)).unwrap()
//       console.log("API Response:", result)
//       if (result?.code === 200) {
//         setSuccessMessage("This mobile number is already verified!")
//         setIsPhoneVerified(true)
//         setLoading(false)
//         return
//       }
//     } catch (err) {
//       console.warn("Phone not verified, proceeding with OTP:", err.message)
//     }

//     try {
//       const phoneNumber = formatPhoneNumber(latestMobile)
//       console.log("Sending OTP to:", phoneNumber)

//       if (!window.recaptchaVerifier) {
//         setupRecaptcha()
//         await new Promise((resolve) => setTimeout(resolve, 500))
//       }

//       const appVerifier = window.recaptchaVerifier
//       if (!appVerifier) {
//         throw new Error("Recaptcha verifier not initialized")
//       }

//       const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier)
//       setConfirmationResult(confirmation)
//       setSuccessMessage("OTP sent successfully!")
//       setOtpSent(true)
//     } catch (otpError) {
//       console.error("OTP Error:", otpError)
//       if (otpError.code === "auth/invalid-phone-number") {
//         setError("Invalid phone number format. Please check and try again.")
//       } else if (otpError.code === "auth/too-many-requests") {
//         setError("Too many requests. Please try again later.")
//       } else if (otpError.code === "auth/quota-exceeded") {
//         setError("SMS quota exceeded. Please try again later.")
//       } else {
//         setError("Error sending OTP. Please try again.")
//       }

//       if (window.recaptchaVerifier) {
//         window.recaptchaVerifier.clear()
//         window.recaptchaVerifier = null
//       }

//       try {
//         setupRecaptcha()
//       } catch (setupError) {
//         console.error("Error reinitializing recaptcha:", setupError)
//       }
//     } finally {
//       setLoading(false)
//     }
//   }

//   const verifyOtp = async (e) => {
//     e.preventDefault()
//     setError("")
//     setSuccessMessage("")
//     setLoading(true)

//     if (!otp.trim()) {
//       setError("Please enter the OTP.")
//       setLoading(false)
//       return
//     }

//     if (!confirmationResult) {
//       setError("Please request OTP first.")
//       setLoading(false)
//       return
//     }

//     try {
//       // Verify OTP with Firebase first
//       const result = await confirmationResult.confirm(otp.trim())
//       console.log("User signed in successfully!", result.user)

//       // If Firebase verification succeeds, verify with our backend API
//       const phoneNumber = formatPhoneNumber(mobile.trim())
//       await dispatch(checkPhoneVerificationPublicAsync({
//         mobile: phoneNumber,
//         code: otp.trim()
//       })).unwrap()

//     } catch (err) {
//       console.error("OTP verification error:", err)
//       if (err.code === "auth/invalid-verification-code") {
//         setError("Invalid OTP. Please check and try again.")
//       } else if (err.code === "auth/code-expired") {
//         setError("OTP has expired. Please request a new one.")
//       } else {
//         setError(err.message || "Invalid OTP. Please try again.")
//       }
//     } finally {
//       setLoading(false)
//     }
//   }

//   const verifyEmail = async (e) => {
//     e.preventDefault()
//     setEmailError("")
//     setEmailSuccessMessage("")
//     dispatch(resetEmailVerificationState())
//     const latestEmail = email.trim()
//     if (!latestEmail) {
//       setEmailError("Please enter a valid email address.")
//       return
//     }
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
//     if (!emailRegex.test(latestEmail)) {
//       setEmailError("Please enter a valid email format.")
//       return
//     }
//     try {
//       await dispatch(generateEmailVerificationPublicAsync()).unwrap()
//       setEmailSuccessMessage("Email verification code sent! Please check your inbox.")
//     } catch (error) {
//       setEmailError(error.message || "Failed to send verification email.")
//     }
//   }

//   const verifyEmailOtp = async (e) => {
//     e.preventDefault()
//     setEmailError("")
//     setEmailSuccessMessage("")

//     if (!emailOtp || emailOtp.length !== 6) {
//       setEmailError("Please enter a valid 6-digit OTP.")
//       return
//     }

//     try {
//       await dispatch(checkEmailVerificationPublicAsync(
//         emailOtp
//       )).unwrap()
//     } catch (error) {
//       setEmailError(error.message || "Invalid OTP. Please try again.")
//     }
//   }

//   const handleSkip = () => {
//     navigate(location.state?.redirectTo || "/employer-basics")
//   }

//   const inputStyles =
//     "h-12 px-4 w-full bg-white border border-gray-200 rounded-lg text-gray-900 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 ease-in-out placeholder-gray-400"
//   const labelStyles = "block text-sm font-medium text-gray-700 mb-1.5"
//   const buttonBaseStyles =
//     "w-full flex justify-center items-center h-12 px-6 border border-transparent rounded-lg text-base font-medium text-white transition-all duration-200 ease-in-out"

//   return (
//     <div
//       className="min-h-screen bg-gradient-to-br from-indigo-50 to-white py-12 px-4 sm:px-6 lg:px-8"
//       style={{ fontFamily: "'Inter', sans-serif" }}
//     >
//       <div className="max-w-2xl mx-auto">
//         <div className="text-center mb-12">
//           <ShieldCheckIcon className="mx-auto h-12 w-12 text-indigo-600" />
//           <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Account Verification</h2>
//           <p className="mt-2 text-sm text-gray-600">Verify your contact details to continue with registration</p>
//         </div>
//         <div className="bg-white shadow-2xl rounded-2xl overflow-hidden">
//           <div className="px-8 py-6 bg-gradient-to-r from-indigo-600 to-blue-500">
//             <h3 className="text-xl font-semibold text-white">Verify Phone & Email</h3>
//             <p className="text-indigo-200">Securely verify your phone number and email address</p>
//           </div>
//           <div className="p-8 space-y-8">
//             {/* Email Verification Section */}
//             <div className="space-y-4">
//               <div className="mb-3 flex items-center justify-between">
//                 <div className="flex items-center space-x-2">
//                   <div
//                     className={`flex h-8 w-8 items-center justify-center rounded-full ${isEmailVerified ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-500"}`}
//                   >
//                     <EnvelopeIcon className="h-4 w-4" />
//                   </div>
//                   <span className="text-sm font-medium text-gray-900">Email Address</span>
//                 </div>
//                 {isEmailVerified && (
//                   <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
//                     <CheckCircleIcon className="-ml-0.5 mr-1.5 h-3 w-3" aria-hidden="true" /> Verified
//                   </span>
//                 )}
//               </div>
//               <div>
//                 <label htmlFor="email-address" className={labelStyles}>
//                   Email Address <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     id="email-address"
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     placeholder="Enter your email address"
//                     className={`${inputStyles} pl-10 ${location.state?.email ? 'bg-gray-100 cursor-not-allowed' : ''}`}
//                     disabled={!!location.state?.email || emailLoading || isEmailVerified || emailOtpSentRedux}
//                     readOnly={!!location.state?.email}
//                   />
//                 </div>
//               </div>
//               <div>
//                 <button
//                   onClick={verifyEmail}
//                   disabled={emailLoading || isEmailVerified || emailOtpSentRedux}
//                   className={`${buttonBaseStyles} ${emailLoading && !emailOtpSentRedux
//                     ? "opacity-50 cursor-not-allowed bg-gray-600"
//                     : isEmailVerified || emailOtpSentRedux
//                       ? "bg-gray-200 text-gray-600 cursor-not-allowed"
//                       : "bg-indigo-600 hover:bg-blue-700 focus:ring-indigo-500"
//                     }`}
//                 >
//                   {emailLoading && !emailOtpSentRedux ? (
//                     <>
//                       <svg
//                         className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                         xmlns="http://www.w3.org/2000/svg"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                       >
//                         <circle
//                           className="opacity-25"
//                           cx="12"
//                           cy="12"
//                           r="10"
//                           stroke="currentColor"
//                           strokeWidth="4"
//                         ></circle>
//                         <path
//                           className="opacity-75"
//                           fill="currentColor"
//                           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                         ></path>
//                       </svg>
//                       Sending Code...
//                     </>
//                   ) : isEmailVerified ? (
//                     "Verified"
//                   ) : emailOtpSentRedux ? (
//                     "Code Sent"
//                   ) : (
//                     "Send Verification Code"
//                   )}
//                 </button>
//               </div>

//               {emailOtpSentRedux && !isEmailVerified && (
//                 <>
//                   <div className="relative">
//                     <div className="absolute inset-0 flex items-center">
//                       <div className="w-full border-t border-gray-200"></div>
//                     </div>
//                     <div className="relative flex justify-center text-sm">
//                       <span className="px-2 bg-white text-gray-500">Enter verification code</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="email-otp" className={labelStyles}>
//                       Verification Code <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       id="email-otp"
//                       type="text"
//                       value={emailOtp}
//                       onChange={(e) => setEmailOtp(e.target.value)}
//                       placeholder="Enter the 6-digit OTP"
//                       className={inputStyles}
//                       maxLength={6}
//                       disabled={emailLoading}
//                     />
//                   </div>
//                   <div>
//                     <button
//                       onClick={verifyEmailOtp}
//                       disabled={emailLoading}
//                       className={`${buttonBaseStyles} ${emailLoading
//                         ? "opacity-50 cursor-not-allowed bg-gray-600"
//                         : "bg-green-600 hover:bg-green-700 focus:ring-green-500"
//                         }`}
//                     >
//                       {emailLoading ? (
//                         <>
//                           <svg
//                             className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                             xmlns="http://www.w3.org/2000/svg"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                           >
//                             <circle
//                               className="opacity-25"
//                               cx="12"
//                               cy="12"
//                               r="10"
//                               stroke="currentColor"
//                               strokeWidth="4"
//                             ></circle>
//                             <path
//                               className="opacity-75"
//                               fill="currentColor"
//                               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                             ></path>
//                           </svg>
//                           Verifying...
//                         </>
//                       ) : (
//                         "Verify Email OTP"
//                       )}
//                     </button>
//                   </div>
//                 </>
//               )}

//               {emailError && (
//                 <div className="rounded-md bg-red-50 p-4">
//                   <div className="flex">
//                     <div className="ml-3">
//                       <p className="text-sm text-red-700">{emailError}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//               {emailSuccessMessage && (
//                 <div className="rounded-md bg-green-50 p-4">
//                   <div className="flex">
//                     <div className="ml-3">
//                       <p className="text-sm text-green-700">{emailSuccessMessage}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="relative">
//               <div className="absolute inset-0 flex items-center">
//                 <div className="w-full border-t border-gray-200"></div>
//               </div>
//               <div className="relative flex justify-center text-sm">
//                 <span className="px-2 bg-white text-gray-500">Or</span>
//               </div>
//             </div>

//             {/* Phone Verification Section */}
//             <div className="space-y-4">
//               <div className="mb-3 flex items-center justify-between">
//                 <div className="flex items-center space-x-2">
//                   <div
//                     className={`flex h-8 w-8 items-center justify-center rounded-full ${isPhoneVerified ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-500"}`}
//                   >
//                     <PhoneIcon className="h-4 w-4" />
//                   </div>
//                   <span className="text-sm font-medium text-gray-900">Phone Number</span>
//                 </div>
//                 {isPhoneVerified && (
//                   <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
//                     <CheckCircleIcon className="-ml-0.5 mr-1.5 h-3 w-3" aria-hidden="true" /> Verified
//                   </span>
//                 )}
//               </div>
//               <div>
//                 <label htmlFor="phone-number" className={labelStyles}>
//                   Phone Number <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     id="phone-number"
//                     type="tel"
//                     value={mobile}
//                     onChange={(e) => setMobile(e.target.value)}
//                     placeholder="Enter your phone number (e.g. 9876543210)"
//                     className={`${inputStyles} ${location.state?.phone ? 'bg-gray-100 cursor-not-allowed' : ''}`}
//                     disabled={!!location.state?.phone || loading || otpSent || isPhoneVerified}
//                     readOnly={!!location.state?.phone}
//                   />
//                 </div>
//                 <p className="text-xs text-gray-500 mt-1">Enter 10-digit mobile number without country code</p>
//               </div>
//               <div>
//                 <button
//                   onClick={sendOtp}
//                   disabled={loading || otpSent || isPhoneVerified}
//                   className={`${buttonBaseStyles} ${loading
//                     ? "opacity-50 cursor-not-allowed bg-gray-600"
//                     : isPhoneVerified
//                       ? "bg-gray-200 text-gray-600 cursor-not-allowed"
//                       : "bg-indigo-600 hover:bg-blue-700 focus:ring-indigo-500"
//                     }`}
//                 >
//                   {loading ? (
//                     <>
//                       <svg
//                         className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                         xmlns="http://www.w3.org/2000/svg"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                       >
//                         <circle
//                           className="opacity-25"
//                           cx="12"
//                           cy="12"
//                           r="10"
//                           stroke="currentColor"
//                           strokeWidth="4"
//                         ></circle>
//                         <path
//                           className="opacity-75"
//                           fill="currentColor"
//                           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                         ></path>
//                       </svg>
//                       Sending OTP...
//                     </>
//                   ) : isPhoneVerified ? (
//                     "Verified"
//                   ) : otpSent ? (
//                     "OTP Sent"
//                   ) : (
//                     "Send Verification Code"
//                   )}
//                 </button>
//               </div>
//               {otpSent && !isPhoneVerified && (
//                 <>
//                   <div className="relative">
//                     <div className="absolute inset-0 flex items-center">
//                       <div className="w-full border-t border-gray-200"></div>
//                     </div>
//                     <div className="relative flex justify-center text-sm">
//                       <span className="px-2 bg-white text-gray-500">Enter verification code</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="otp" className={labelStyles}>
//                       Verification Code <span className="text-red-500">*</span>
//                     </label>
//                     <input
//                       id="otp"
//                       type="text"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                       placeholder="Enter the 6-digit OTP"
//                       className={inputStyles}
//                       maxLength="6"
//                       disabled={loading}
//                     />
//                   </div>
//                   <div>
//                     <button
//                       onClick={verifyOtp}
//                       disabled={loading}
//                       className={`${buttonBaseStyles} ${loading
//                         ? "opacity-50 cursor-not-allowed bg-gray-600"
//                         : "bg-green-600 hover:bg-green-700 focus:ring-green-500"
//                         }`}
//                     >
//                       {loading ? (
//                         <>
//                           <svg
//                             className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                             xmlns="http://www.w3.org/2000/svg"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                           >
//                             <circle
//                               className="opacity-25"
//                               cx="12"
//                               cy="12"
//                               r="10"
//                               stroke="currentColor"
//                               strokeWidth="4"
//                             ></circle>
//                             <path
//                               className="opacity-75"
//                               fill="currentColor"
//                               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                             ></path>
//                           </svg>
//                           Verifying...
//                         </>
//                       ) : (
//                         "Verify OTP"
//                       )}
//                     </button>
//                   </div>
//                 </>
//               )}
//               {error && (
//                 <div className="rounded-md bg-red-50 p-4">
//                   <div className="flex">
//                     <div className="ml-3">
//                       <p className="text-sm text-red-700">{error}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//               {successMessage && (
//                 <div className="rounded-md bg-green-50 p-4">
//                   <div className="flex">
//                     <div className="ml-3">
//                       <p className="text-sm text-green-700">{successMessage}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="relative">
//               <div className="absolute inset-0 flex items-center">
//                 <div className="w-full border-t border-gray-200"></div>
//               </div>
//               <div className="relative flex justify-center text-sm">
//                 <span className="px-2 bg-white text-gray-500">Or</span>
//               </div>
//             </div>
//             <div>
//               <button
//                 onClick={handleSkip}
//                 className="w-full flex justify-center items-center h-12 px-6 border border-gray-300 rounded-lg text-base font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 ease-in-out"
//               >
//                 Skip for now
//                 <ArrowRightIcon className="h-5 w-5 ml-2" />
//               </button>
//             </div>
//             <div className="text-center">
//               <p className="text-sm text-gray-500">
//                 By continuing, you agree to our{" "}
//                 <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
//                   Terms of Service
//                 </a>{" "}
//                 and{" "}
//                 <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
//                   Privacy Policy
//                 </a>
//                 .
//               </p>
//             </div>
//           </div>
//         </div>
//         <div id="recaptcha-container" className="mt-8 flex justify-center"></div>
//       </div>
//     </div>
//   )
// }

// export default PhoneVerification

"use client"

import { useState, useEffect, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import { PhoneIcon, ShieldCheckIcon, ArrowRightIcon, EnvelopeIcon, CheckCircleIcon, ExclamationTriangleIcon, ArrowPathIcon } from "@heroicons/react/24/outline"

// Assuming these are correctly configured and available
import { auth, setupRecaptcha, signInWithPhoneNumber } from "../../../firebaseConfig"
import { CheckPhoneVerifyAsync } from "../Slice/PhoneVerified/CheckPhoneVerifySlice"
import {
  generateEmailVerificationPublicAsync,
  checkEmailVerificationPublicAsync,
  resetEmailVerificationState,
} from "../Slice/EmailVerificationSignup/EmailVerificationSignupSlice"
import { checkPhoneVerificationPublicAsync, resetPhoneVerificationState } from "../Slice/PhoneVerificationSignup/PhoneVerificationSignupSlice"
import { fetchProfileAsync, selectCompanyProfile } from "../../employerDashboard/employerDashAPIs/companyProfile/CompanyProfileSlice"
import { fetchCookie } from "../../common/FetchCookie"

// Resend OTP cooldown time in seconds
const RESEND_COOLDOWN = 120

function PhoneVerification() {
  const location = useLocation()
  const [mobile, setMobile] = useState(location.state?.phone || "")
  const [email, setEmail] = useState(location.state?.email || "")
  const [otp, setOtp] = useState("")
  const [confirmationResult, setConfirmationResult] = useState(null)
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [isPhoneVerified, setIsPhoneVerified] = useState(false)
  const [otpSent, setOtpSent] = useState(false)
  const basicdetails = useSelector(selectCompanyProfile)

  // Auth type state - 'form' or 'oauth'
  const [authType, setAuthType] = useState(null)
  const [isAuthTypeLoaded, setIsAuthTypeLoaded] = useState(false)

  // Phone number already exists state (for OAuth)
  const [phoneAlreadyExists, setPhoneAlreadyExists] = useState(false)

  // Email verification states
  const [emailOtp, setEmailOtp] = useState("")
  const [emailError, setEmailError] = useState("")
  const [emailSuccessMessage, setEmailSuccessMessage] = useState("")
  const [isEmailVerified, setIsEmailVerified] = useState(false)

  // Resend OTP timer states
  const [phoneResendTimer, setPhoneResendTimer] = useState(0)
  const [emailResendTimer, setEmailResendTimer] = useState(0)
  const [canResendPhoneOtp, setCanResendPhoneOtp] = useState(false)
  const [canResendEmailOtp, setCanResendEmailOtp] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  // Phone verification state from Redux
  const {
    loading: phoneLoading,
    success: phoneVerifiedRedux,
    error: phoneReduxError,
  } = useSelector((state) => state.phoneVerificationPublic || {})

  // Email verification state from Redux
  const {
    loading: emailLoading,
    otpSent: emailOtpSentRedux,
    success: emailVerifiedRedux,
    error: emailReduxError,
  } = useSelector((state) => state.emailVerificationPublic || {})

  // Phone resend timer effect
  useEffect(() => {
    let interval = null
    if (phoneResendTimer > 0) {
      interval = setInterval(() => {
        setPhoneResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResendPhoneOtp(true)
            return 0
          }
          return prevTimer - 1
        })
      }, 1000)
    }
    return () => {
      if (interval) clearInterval(interval)
    }
  }, [phoneResendTimer])

  // Email resend timer effect
  useEffect(() => {
    let interval = null
    if (emailResendTimer > 0) {
      interval = setInterval(() => {
        setEmailResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResendEmailOtp(true)
            return 0
          }
          return prevTimer - 1
        })
      }, 1000)
    }
    return () => {
      if (interval) clearInterval(interval)
    }
  }, [emailResendTimer])

  // Start phone resend timer
  const startPhoneResendTimer = useCallback(() => {
    setPhoneResendTimer(RESEND_COOLDOWN)
    setCanResendPhoneOtp(false)
  }, [])

  // Start email resend timer
  const startEmailResendTimer = useCallback(() => {
    setEmailResendTimer(RESEND_COOLDOWN)
    setCanResendEmailOtp(false)
  }, [])

  // Format timer display
  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  // Fetch auth type from cookie on mount
  useEffect(() => {
    const getAuthType = async () => {
      try {
        const userData = await fetchCookie()
        const registerType = userData?.user?.register_type || userData?.register_type

        // Handle both 'oauth' and 'google' as OAuth type
        if (registerType === 'oauth' || registerType === 'google') {
          setAuthType('oauth')
        } else {
          setAuthType('form')
        }

        // Also prefill email from cookie if not already set
        if (!email && userData?.user?.email) {
          setEmail(userData.user.email)
        }

        // Prefill phone from cookie if available (for form type)
        if (!mobile && userData?.user?.phone) {
          setMobile(String(userData.user.phone))
        }

      } catch (error) {
        console.error("Error fetching auth type:", error)
        setAuthType('form') // Default to 'form' on error
      } finally {
        setIsAuthTypeLoaded(true)
      }
    }
    getAuthType()
  }, [])

  // Setup recaptcha when component mounts
  useEffect(() => {
    const initializeRecaptcha = () => {
      try {
        setupRecaptcha()
      } catch (error) {
        console.error("Error initializing recaptcha:", error)
      }
    }
    const timer = setTimeout(initializeRecaptcha, 100)
    return () => {
      clearTimeout(timer)
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear()
        window.recaptchaVerifier = null
      }
    }
  }, [])

  // Reset verification states on component mount
  useEffect(() => {
    dispatch(resetEmailVerificationState())
    dispatch(resetPhoneVerificationState())
    dispatch(fetchProfileAsync())
  }, [dispatch])

  // Prefill email and phone from basicdetails
  useEffect(() => {
    if (basicdetails) {
      if (basicdetails.email && !email) {
        setEmail(basicdetails.email)
      }
      // For form signup, prefill phone from basicdetails
      if (authType === 'form' && basicdetails.phone && !mobile) {
        setMobile(String(basicdetails.phone))
      }
      // Check if already verified from API response
      if (basicdetails.user?.email_verify === 1) {
        setIsEmailVerified(true)
      }
      if (basicdetails.user?.phone_verify === 1) {
        setIsPhoneVerified(true)
      }
    }
  }, [basicdetails, email, mobile, authType])

  // Handle phone verification success
  useEffect(() => {
    if (phoneVerifiedRedux) {
      setIsPhoneVerified(true)
      setSuccessMessage("Phone verification successful!")
      setOtp("")
      setTimeout(() => {
        navigate(location.state?.redirectTo || "/employer-basics", {
          state: {
            country_uuid: location.state?.country_uuid,
            state_uuid: location.state?.state_uuid,
            city_uuid: location.state?.city_uuid,
          }
        });
      }, 1500);
    }
  }, [phoneVerifiedRedux, navigate, location.state])

  // Handle phone verification error
  useEffect(() => {
    if (phoneReduxError) {
      setError(phoneReduxError)
    }
  }, [phoneReduxError])

  // Handle email verification success
  useEffect(() => {
    if (emailVerifiedRedux) {
      setIsEmailVerified(true)
      setEmailSuccessMessage("Email verification successful!")
      setEmailOtp("")
    }
  }, [emailVerifiedRedux])

  // Handle email verification error
  useEffect(() => {
    if (emailReduxError) {
      setEmailError(emailReduxError)
    }
  }, [emailReduxError])

  useEffect(() => {
   
  }, [emailOtpSentRedux, isEmailVerified, authType, email, mobile])

  const formatPhoneNumber = (phone) => {
    if (!phone) return ""
    const cleaned = phone.toString().replace(/\D/g, "")
    if (phone.toString().startsWith("+91")) {
      return phone.toString()
    }
    if (cleaned.length === 10) {
      return `+91${cleaned}`
    }
    if (cleaned.startsWith("91") && cleaned.length === 12) {
      return `+${cleaned}`
    }
    return `+91${cleaned}`
  }

  const validatePhoneNumber = (phone) => {
    if (!phone) return false
    const cleaned = phone.toString().replace(/\D/g, "")
    return cleaned.length === 10 || (cleaned.length === 12 && cleaned.startsWith("91"))
  }

  // Helper function to send OTP via Firebase
  const sendOtpViaFirebase = async (phoneNumber) => {
    try {

      if (!window.recaptchaVerifier) {
        setupRecaptcha()
        await new Promise((resolve) => setTimeout(resolve, 500))
      }

      const appVerifier = window.recaptchaVerifier
      if (!appVerifier) {
        throw new Error("Recaptcha verifier not initialized")
      }

      const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      setConfirmationResult(confirmation)
      setSuccessMessage("OTP sent successfully!")
      setOtpSent(true)
      setPhoneAlreadyExists(false) // Reset the flag on successful OTP send
      startPhoneResendTimer() // Start the resend timer
    } catch (otpError) {
      console.error("OTP Error:", otpError)
      if (otpError.code === "auth/invalid-phone-number") {
        setError("Invalid phone number format. Please check and try again.")
      } else if (otpError.code === "auth/too-many-requests") {
        setError("Too many requests. Please try again later.")
      } else if (otpError.code === "auth/quota-exceeded") {
        setError("SMS quota exceeded. Please try again later.")
      } else {
        setError("Error sending OTP. Please try again.")
      }

      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear()
        window.recaptchaVerifier = null
      }

      try {
        setupRecaptcha()
      } catch (setupError) {
        console.error("Error reinitializing recaptcha:", setupError)
      }
    }
  }

  // Handle phone number change for OAuth users
  const handlePhoneChange = (e) => {
    const newPhone = e.target.value
    setMobile(newPhone)
    // Reset states when user changes phone number
    setError("")
    setSuccessMessage("")
    setPhoneAlreadyExists(false)
    setOtpSent(false)
    setConfirmationResult(null)
    setOtp("")
    setPhoneResendTimer(0)
    setCanResendPhoneOtp(false)
  }

  const sendOtp = async (e) => {
    e.preventDefault()
    setError("")
    setSuccessMessage("")
    setPhoneAlreadyExists(false)
    setLoading(true)
    const latestMobile = mobile.toString().trim()

    if (!latestMobile) {
      setError("Please enter a valid phone number.")
      setLoading(false)
      return
    }

    if (!validatePhoneNumber(latestMobile)) {
      setError("Please enter a valid 10-digit phone number.")
      setLoading(false)
      return
    }

    const phoneNumber = formatPhoneNumber(latestMobile)

    // Check auth type to determine flow
    if (authType === 'form') {
      // For form signup, skip CheckPhoneVerifyAsync and directly send OTP
      try {
        await sendOtpViaFirebase(phoneNumber)
      } catch (err) {
        console.error("Error sending OTP for form signup:", err)
      }
    } else if (authType === 'oauth') {
      // For OAuth signup, check if phone exists in database first
      try {
        const result = await dispatch(CheckPhoneVerifyAsync(latestMobile)).unwrap()

        // If phone already exists/verified, show error and allow re-entry
        if (result?.code === 200) {
          setPhoneAlreadyExists(true)
          setError("This phone number is already registered with another account. Please enter a different phone number.")
          setLoading(false)
          return
        }
      } catch (err) {
        // Phone not found in database or not verified, proceed with OTP
        console.warn("Phone not verified in database, proceeding with OTP:", err.message)
        setPhoneAlreadyExists(false)
      }

      // Send OTP via Firebase
      try {
        await sendOtpViaFirebase(phoneNumber)
      } catch (err) {
        console.error("Error sending OTP for OAuth signup:", err)
      }
    } else {
      // Default behavior - same as form (skip check)
      try {
        await sendOtpViaFirebase(phoneNumber)
      } catch (err) {
        console.error("Error sending OTP:", err)
      }
    }

    setLoading(false)
  }

  // Resend Phone OTP
  const resendPhoneOtp = async (e) => {
    e.preventDefault()
    if (!canResendPhoneOtp) return

    setError("")
    setSuccessMessage("")
    setOtp("")
    setLoading(true)

    const phoneNumber = formatPhoneNumber(mobile.toString().trim())

    // Clear and reinitialize recaptcha for resend
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear()
      window.recaptchaVerifier = null
    }

    try {
      setupRecaptcha()
      await new Promise((resolve) => setTimeout(resolve, 500))
      await sendOtpViaFirebase(phoneNumber)
    } catch (err) {
      console.error("Error resending OTP:", err)
      setError("Error resending OTP. Please try again.")
    }

    setLoading(false)
  }

  const verifyOtp = async (e) => {
    e.preventDefault()
    setError("")
    setSuccessMessage("")
    setLoading(true)

    if (!otp.trim()) {
      setError("Please enter the OTP.")
      setLoading(false)
      return
    }

    if (!confirmationResult) {
      setError("Please request OTP first.")
      setLoading(false)
      return
    }

    try {
      // Verify OTP with Firebase first
      const result = await confirmationResult.confirm(otp.trim())

      // If Firebase verification succeeds, verify with our backend API
      const phoneNumber = formatPhoneNumber(mobile.toString().trim())

      // Send data in correct format: { mobile: "...", code: "..." }
      await dispatch(checkPhoneVerificationPublicAsync({
        mobile: phoneNumber,
        code: otp.trim()
      })).unwrap()

    } catch (err) {
      console.error("OTP verification error:", err)
      if (err.code === "auth/invalid-verification-code") {
        setError("Invalid OTP. Please check and try again.")
      } else if (err.code === "auth/code-expired") {
        setError("OTP has expired. Please request a new one.")
      } else {
        setError(err.message || "Invalid OTP. Please try again.")
      }
    } finally {
      setLoading(false)
    }
  }

  const verifyEmail = async (e) => {
    e.preventDefault()
    setEmailError("")
    setEmailSuccessMessage("")
    dispatch(resetEmailVerificationState())
    const latestEmail = email.trim()
    if (!latestEmail) {
      setEmailError("Please enter a valid email address.")
      return
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(latestEmail)) {
      setEmailError("Please enter a valid email format.")
      return
    }
    try {
      await dispatch(generateEmailVerificationPublicAsync()).unwrap()
      setEmailSuccessMessage("Email verification code sent! Please check your inbox.")
      startEmailResendTimer() // Start the resend timer
    } catch (error) {
      setEmailError(error.message || "Failed to send verification email.")
    }
  }

  // Resend Email OTP
  const resendEmailOtp = async (e) => {
    e.preventDefault()
    if (!canResendEmailOtp) return

    setEmailError("")
    setEmailSuccessMessage("")
    setEmailOtp("")
    dispatch(resetEmailVerificationState())

    try {
      await dispatch(generateEmailVerificationPublicAsync()).unwrap()
      setEmailSuccessMessage("Email verification code resent! Please check your inbox.")
      startEmailResendTimer() // Restart the timer
    } catch (error) {
      setEmailError(error.message || "Failed to resend verification email.")
    }
  }

  const verifyEmailOtp = async (e) => {
    e.preventDefault()
    setEmailError("")
    setEmailSuccessMessage("")

    if (!emailOtp || emailOtp.length !== 6) {
      setEmailError("Please enter a valid 6-digit OTP.")
      return
    }

    try {
      await dispatch(checkEmailVerificationPublicAsync(emailOtp)).unwrap()
    } catch (error) {
      setEmailError(error.message || "Invalid OTP. Please try again.")
    }
  }

  const handleSkip = () => {
    navigate(location.state?.redirectTo || "/employer-basics")
  }

  // Check if we have phone from location state or basicdetails (only for form type)
  const hasPhoneFromSource = authType === 'form' && !!(location.state?.phone || basicdetails?.phone)

  // Determine if phone field should be editable
  // For form signup: phone is prefilled and NOT editable
  // For oauth signup: phone is ALWAYS editable (user needs to enter/change it)
  const isPhoneFieldDisabled = () => {
    if (authType === 'form') return true // Form users cannot edit phone
    if (loading) return true // Disable during loading
    if (otpSent && !phoneAlreadyExists) return true // Disable after OTP sent (but not if phone exists error)
    if (isPhoneVerified) return true // Disable if already verified
    return false // OAuth users can edit
  }

  const isPhoneFieldReadOnly = () => {
    return authType === 'form' // Only form users have readonly
  }

  const inputStyles =
    "h-12 px-4 w-full bg-white border border-gray-200 rounded-lg text-gray-900 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 ease-in-out placeholder-gray-400"
  const labelStyles = "block text-sm font-medium text-gray-700 mb-1.5"
  const buttonBaseStyles =
    "w-full flex justify-center items-center h-12 px-6 border border-transparent rounded-lg text-base font-medium text-white transition-all duration-200 ease-in-out"

  // Show loading state while fetching auth type
  if (!isAuthTypeLoaded) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-white py-12 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
        <div className="text-center">
          <svg
            className="animate-spin h-10 w-10 text-indigo-600 mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-indigo-50 to-white py-12 px-4 sm:px-6 lg:px-8"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <ShieldCheckIcon className="mx-auto h-12 w-12 text-indigo-600" />
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Account Verification</h2>
          <p className="mt-2 text-sm text-gray-600">Verify your contact details to continue with registration</p>
          {authType && (
            <p className="mt-1 text-xs text-gray-400">
              Signed up via: <span className="font-medium capitalize">{authType === 'oauth' ? 'Google OAuth' : 'Form'}</span>
            </p>
          )}
        </div>
        <div className="bg-white shadow-2xl rounded-2xl overflow-hidden">
          <div className="px-8 py-6 bg-gradient-to-r from-indigo-600 to-blue-500">
            <h3 className="text-xl font-semibold text-white">Verify Phone & Email</h3>
            <p className="text-indigo-200">Securely verify your phone number and email address</p>
          </div>
          <div className="p-8 space-y-8">
            {/* Email Verification Section */}
            <div className="space-y-4">
              <div className="mb-3 flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-full ${isEmailVerified ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-500"}`}
                  >
                    <EnvelopeIcon className="h-4 w-4" />
                  </div>
                  <span className="text-sm font-medium text-gray-900">Email Address</span>
                </div>
                {isEmailVerified && (
                  <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                    <CheckCircleIcon className="-ml-0.5 mr-1.5 h-3 w-3" aria-hidden="true" /> Verified
                  </span>
                )}
              </div>
              <div>
                <label htmlFor="email-address" className={labelStyles}>
                  Email Address <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    id="email-address"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className={`${inputStyles} pl-4 bg-gray-100 cursor-not-allowed`}
                    disabled={true}
                    readOnly={true}
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Email address from your registration (cannot be changed)
                </p>
              </div>
              <div>
                <button
                  onClick={verifyEmail}
                  disabled={emailLoading || isEmailVerified || emailOtpSentRedux || !email}
                  className={`${buttonBaseStyles} ${emailLoading && !emailOtpSentRedux
                    ? "opacity-50 cursor-not-allowed bg-gray-600"
                    : isEmailVerified || emailOtpSentRedux
                      ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                      : !email
                        ? "opacity-50 cursor-not-allowed bg-gray-400"
                        : "bg-indigo-600 hover:bg-blue-700 focus:ring-indigo-500"
                    }`}
                >
                  {emailLoading && !emailOtpSentRedux ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Sending Code...
                    </>
                  ) : isEmailVerified ? (
                    "Verified"
                  ) : emailOtpSentRedux ? (
                    "Code Sent"
                  ) : (
                    "Send Verification Code"
                  )}
                </button>
              </div>

              {emailOtpSentRedux && !isEmailVerified && (
                <>
                  <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-gray-200"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-2 bg-white text-gray-500">Enter verification code</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="email-otp" className={labelStyles}>
                      Verification Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="email-otp"
                      type="text"
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                      placeholder="Enter the 6-digit OTP"
                      className={inputStyles}
                      maxLength={6}
                      disabled={emailLoading}
                    />
                  </div>

                  {/* Email Resend OTP Button */}
                  <div className="flex items-center justify-between">
                    <button
                      onClick={resendEmailOtp}
                      disabled={!canResendEmailOtp || emailLoading}
                      className={`flex items-center text-sm ${canResendEmailOtp && !emailLoading
                          ? "text-indigo-600 hover:text-indigo-800 cursor-pointer"
                          : "text-gray-400 cursor-not-allowed"
                        }`}
                    >
                      <ArrowPathIcon className={`h-4 w-4 mr-1 ${emailLoading ? 'animate-spin' : ''}`} />
                      {canResendEmailOtp ? "Resend OTP" : `Resend in ${formatTimer(emailResendTimer)}`}
                    </button>
                    {emailResendTimer > 0 && (
                      <span className="text-xs text-gray-500">
                        Please wait before requesting a new code
                      </span>
                    )}
                  </div>

                  <div>
                    <button
                      onClick={verifyEmailOtp}
                      disabled={emailLoading}
                      className={`${buttonBaseStyles} ${emailLoading
                        ? "opacity-50 cursor-not-allowed bg-gray-600"
                        : "bg-green-600 hover:bg-green-700 focus:ring-green-500"
                        }`}
                    >
                      {emailLoading ? (
                        <>
                          <svg
                            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Verifying...
                        </>
                      ) : (
                        "Verify Email OTP"
                      )}
                    </button>
                  </div>
                </>
              )}

              {emailError && (
                <div className="rounded-md bg-red-50 p-4">
                  <div className="flex">
                    <div className="ml-3">
                      <p className="text-sm text-red-700">{emailError}</p>
                    </div>
                  </div>
                </div>
              )}
              {emailSuccessMessage && (
                <div className="rounded-md bg-green-50 p-4">
                  <div className="flex">
                    <div className="ml-3">
                      <p className="text-sm text-green-700">{emailSuccessMessage}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">And</span>
              </div>
            </div>

            {/* Phone Verification Section */}
            <div className="space-y-4">
              <div className="mb-3 flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-full ${isPhoneVerified ? "bg-green-100 text-green-600" : phoneAlreadyExists ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-500"}`}
                  >
                    <PhoneIcon className="h-4 w-4" />
                  </div>
                  <span className="text-sm font-medium text-gray-900">Phone Number</span>
                  {authType === 'oauth' && (
                    <span className="text-xs text-blue-500 ml-2">(Enter your phone number)</span>
                  )}
                </div>
                {isPhoneVerified && (
                  <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                    <CheckCircleIcon className="-ml-0.5 mr-1.5 h-3 w-3" aria-hidden="true" /> Verified
                  </span>
                )}
              </div>
              <div>
                <label htmlFor="phone-number" className={labelStyles}>
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    id="phone-number"
                    type="tel"
                    value={mobile}
                    onChange={authType === 'oauth' ? handlePhoneChange : undefined}
                    placeholder={authType === 'oauth' ? "Enter your phone number (e.g. 9876543210)" : "Phone number from registration"}
                    className={`${inputStyles} ${isPhoneFieldDisabled() ? 'bg-gray-100 cursor-not-allowed' : ''
                      } ${phoneAlreadyExists ? 'border-red-500 focus:ring-red-500' : ''}`}
                    disabled={isPhoneFieldDisabled()}
                    readOnly={isPhoneFieldReadOnly()}
                  />
                  {phoneAlreadyExists && (
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <ExclamationTriangleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                    </div>
                  )}
                </div>
                <p className={`text-xs mt-1 ${phoneAlreadyExists ? 'text-red-500' : 'text-gray-500'}`}>
                  {authType === 'form'
                    ? "Phone number from your registration (cannot be changed)"
                    : phoneAlreadyExists
                      ? "This number is already registered. Please enter a different number."
                      : "Enter your 10-digit mobile number without country code"
                  }
                </p>
              </div>

              {/* Phone Already Exists Warning */}
              {phoneAlreadyExists && (
                <div className="rounded-md bg-yellow-50 border border-yellow-200 p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-yellow-800">Phone Number Already Registered</h3>
                      <div className="mt-2 text-sm text-yellow-700">
                        <p>
                          This phone number is already associated with another account.
                          Please enter a different phone number to continue.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div>
                <button
                  onClick={sendOtp}
                  disabled={loading || (otpSent && !phoneAlreadyExists) || isPhoneVerified || !mobile.toString().trim()}
                  className={`${buttonBaseStyles} ${loading
                    ? "opacity-50 cursor-not-allowed bg-gray-600"
                    : isPhoneVerified
                      ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                      : !mobile.toString().trim()
                        ? "opacity-50 cursor-not-allowed bg-gray-400"
                        : phoneAlreadyExists
                          ? "bg-orange-600 hover:bg-orange-700 focus:ring-orange-500"
                          : "bg-indigo-600 hover:bg-blue-700 focus:ring-indigo-500"
                    }`}
                >
                  {loading ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      {authType === 'oauth' ? "Checking & Sending OTP..." : "Sending OTP..."}
                    </>
                  ) : isPhoneVerified ? (
                    "Verified"
                  ) : otpSent && !phoneAlreadyExists ? (
                    "OTP Sent"
                  ) : phoneAlreadyExists ? (
                    "Try Different Number"
                  ) : (
                    "Send Verification Code"
                  )}
                </button>
              </div>

              {otpSent && !isPhoneVerified && !phoneAlreadyExists && (
                <>
                  <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-gray-200"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-2 bg-white text-gray-500">Enter verification code</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="otp" className={labelStyles}>
                      Verification Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="otp"
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder="Enter the 6-digit OTP"
                      className={inputStyles}
                      maxLength="6"
                      disabled={loading}
                    />
                  </div>

                  {/* Phone Resend OTP Button */}
                  <div className="flex items-center justify-between">
                    <button
                      onClick={resendPhoneOtp}
                      disabled={!canResendPhoneOtp || loading}
                      className={`flex items-center text-sm ${canResendPhoneOtp && !loading
                          ? "text-indigo-600 hover:text-indigo-800 cursor-pointer"
                          : "text-gray-400 cursor-not-allowed"
                        }`}
                    >
                      <ArrowPathIcon className={`h-4 w-4 mr-1 ${loading ? 'animate-spin' : ''}`} />
                      {canResendPhoneOtp ? "Resend OTP" : `Resend in ${formatTimer(phoneResendTimer)}`}
                    </button>
                    {phoneResendTimer > 0 && (
                      <span className="text-xs text-gray-500">
                        Please wait before requesting a new code
                      </span>
                    )}
                  </div>

                  <div>
                    <button
                      onClick={verifyOtp}
                      disabled={loading}
                      className={`${buttonBaseStyles} ${loading
                        ? "opacity-50 cursor-not-allowed bg-gray-600"
                        : "bg-green-600 hover:bg-green-700 focus:ring-green-500"
                        }`}
                    >
                      {loading ? (
                        <>
                          <svg
                            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Verifying...
                        </>
                      ) : (
                        "Verify OTP"
                      )}
                    </button>
                  </div>
                </>
              )}

              {error && !phoneAlreadyExists && (
                <div className="rounded-md bg-red-50 p-4">
                  <div className="flex">
                    <div className="ml-3">
                      <p className="text-sm text-red-700">{error}</p>
                    </div>
                  </div>
                </div>
              )}
              {successMessage && (
                <div className="rounded-md bg-green-50 p-4">
                  <div className="flex">
                    <div className="ml-3">
                      <p className="text-sm text-green-700">{successMessage}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">Or</span>
              </div>
            </div>
            <div>
              <button
                onClick={handleSkip}
                className="w-full flex justify-center items-center h-12 px-6 border border-gray-300 rounded-lg text-base font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 ease-in-out"
              >
                Skip for now
                <ArrowRightIcon className="h-5 w-5 ml-2" />
              </button>
            </div>
            <div className="text-center">
              <p className="text-sm text-gray-500">
                By continuing, you agree to our{" "}
                <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                  Terms of Service
                </a>{" "}
                and{" "}
                <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                  Privacy Policy
                </a>
                .
              </p>
            </div>
          </div>
        </div>
        <div id="recaptcha-container" className="mt-8 flex justify-center"></div>
      </div>
    </div>
  )
}

export default PhoneVerification